import React from "react";
import { connect } from "react-redux";
import "./_CollectionSelect.scss";
import { Link } from "react-router-dom";
import { SelectButton } from "..";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import slugify from "slugify";

class CollectionSelect extends React.Component {
  renderCollectionList = () => {
    const { collectionsList, selectButtonText, history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;

    if (queryParams && collectionsList) {
      return collectionsList.items.map((item) => {
        if (queryParams.view === "collection") {
          if (item.necklace === false) {
            return (
              <Link
                to={`/?view=digital-showroom&collection=${slugify(
                  item.title
                )}&ring=default&holder=default&ring-material=yellow-gold&holder-material=yellow-gold`}
                className="collection-item"
                key={item.title}
                id={`collection-item-${item.title.toLowerCase()}`}
                onMouseEnter={() =>
                  this.onHover(`collection-item-${item.title.toLowerCase()}`)
                }
                onMouseLeave={() =>
                  this.onHoverExit(
                    `collection-item-${item.title.toLowerCase()}`
                  )
                }
              >
                <img src={item.imageURL} alt="collection item" />
                <span className="collection-item-title">{item.title}</span>
                <SelectButton buttonText={selectButtonText} />
              </Link>
            );
          } else {
            return null;
          }
        } else if (queryParams.view === "collection-necklace") {
          if (item.necklace === true) {
            return (
              <Link
                to={`/?view=digital-showroom-necklace&collection=${slugify(
                  item.title
                )}&necklace=default&necklace-material=yellow-gold`}
                className="collection-item collection-item-necklace"
                key={item.title}
                id={`collection-item-${item.title.toLowerCase()}`}
                onMouseEnter={() =>
                  this.onHover(`collection-item-${item.title.toLowerCase()}`)
                }
                onMouseLeave={() =>
                  this.onHoverExit(
                    `collection-item-${item.title.toLowerCase()}`
                  )
                }
              >
                <img src={item.imageURL} alt="collection item" />
                <span className="collection-item-title">{item.title}</span>
                <SelectButton buttonText={selectButtonText} />
              </Link>
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
    }
  };

  onHover = (id) => {
    document.getElementById(id).classList.add("hovered");
  };

  onHoverExit = (id) => {
    document.getElementById(id).classList.remove("hovered");
  };

  render() {
    return (
      <div className="collection-select">{this.renderCollectionList()}</div>
    );
  }
}

const mapStateToProps = ({ collection, collectionPage }) => {
  const { selectButtonText } = collectionPage;
  const { collectionsList } = collection;

  return {
    collectionsList,
    selectButtonText,
  };
};

export default connect(mapStateToProps, {})(withRouter(CollectionSelect));
